import styled, { css } from 'styled-components';
import { SubmitButton } from 'formik-antd';
import { Button } from 'antd';
import { Text, Flex, Box } from 'atoms';

export const SaveBtn = styled(SubmitButton)`
	width: 96px;
	height: 40px;
	border: 1px solid ${(props) => props.theme.colors.primary};
	border-radius: 4px;
	background-color: white;
	color: ${(props) => props.theme.colors.primary};
	font-size: 12px;
	text-align: center;
	cursor: pointer;
	&:disabled {
		background: #dddddd;
	}
`;

export const ConfirmBtn = styled(Button)`
	width: 96px;
	height: 40px;
	border: 1px solid ${(props) => props.theme.colors.primary};
	border-radius: 4px;
	background-color: white;
	font-size: 12px;
	text-align: center;
	color: ${(props) => props.theme.colors.primary};
	cursor: pointer;
	&:disabled {
		background: #dddddd;
	}
`;

export const ClearBtn = styled(Button)`
	width: 96px;
	height: 40px;
`;

export const Label = styled(Text)`
	min-width: 65px;
	padding-top: 7px;
	font-size: 10px;
	font-weight: 600;
	text-align: left;
	color: ${(props) => props.theme.colors.SpaceCadet};
	min-width: ${(props) => (props.noMinWidth ? `auto` : `65px`)};
`;

export const BillType = styled(Text)`
	min-height: 48px;
	border-bottom-left-radius: 4px;
	background-color: ${(props) => (props.isValidAmount ? props.theme.colors.primary : `#fff`)};
	font-size: 10px;
	font-weight: 600;
	color: ${(props) => (props.isValidAmount ? `#fff` : props.theme.colors.SpaceCadet)};
	text-align: center;
	line-height: 49px;
`;

export const Bill = styled(Flex)`
	background-color: ${(props) => props.theme.colors.Cultured};
	border-bottom: 0.6px solid ${(props) => props.theme.colors.LightGray};
	padding: 1rem 1rem 0.5rem 1rem;
	${(props) =>
		props.isLast &&
		css`
			border-bottom: 0;
		`}
`;

export const BillNo = styled.div`
	color: ${(props) => props.theme.colors.primary};
	font-size: 14px;
	text-transform: uppercase;
`;

export const AmountFilled = styled.div`
	border: 1px solid
		${(props) =>
			props.isValid ? props.theme.colors.CelticBlue : props.theme.colors.ErrorMessage};
	${(props) =>
		!props.isValid &&
		css`
			color: ${props.theme.colors.ErrorMessage};
		`}
	border-radius: 5px;
	height: 32px;
	position: relative;

	.label {
		font-weight: 300;
		font-size: 10px;
		position: absolute;
		top: -8px;
		left: 12px;
		background-color: ${(props) => props.theme.colors.white};
		padding: 0 10px;
	}

	.value {
		font-weight: 400;
		font-size: 14px;
		position: relative;
		top: 4px;
		left: 12px;
	}
`;

export const UTRInfo = styled(Flex)`
	justify-content: space-between;
	align-items: center;
	padding: 0.5rem;
	border: 1px solid #ebebeb;
	box-shadow: 0px 2px 2px rgba(232, 232, 232, 0.15);
	border-radius: 4px;
`;

export const UTRInforBox = styled(Box)`
	border: 0.5px solid #17224d;
	border-bottom: 0;
	padding: 0.5rem;
`;

export const ImageBox = styled(Flex)`
	justify-content: center;
	align-items: center;
	background-color: #ebf5ff;
	width: 30px;
	height: 30px;
	border-radius: 2px;
`;
